import 'core-js';
import 'isomorphic-fetch';

import scrollControl from './services/scrollControl';
import initCookieConsent from './services/cookieConsent';
import observeMenuState from './services/menuStateObserver';
import initWeeklyBars from './services/weeklyBars';
import initTableBars from './services/tableBars';
import initAutocomplete from './services/autocomplete';
import PeriodSwitcher from './services/PeriodSwitcher';
import Banner from './services/banner';
import initFilters from './services/filter';
import { searchParamSaversManager } from './services/searchParams';
import initBlackFridayBanner from './services/blackFridayBanner';
import initWebinarBanner from './services/webinarBanner';
import initSpringBanner from './services/springBanner';

$(document).ready(() => {
  $.widget.bridge('uitooltip', $.ui.tooltip);
  observeMenuState();
  initAutocomplete();
  initWeeklyBars();
  initTableBars();
  initCookieConsent();
  scrollControl.init();
  PeriodSwitcher.init();
  initFilters();
  searchParamSaversManager.init();
  initBlackFridayBanner();
  initWebinarBanner();
  initSpringBanner();
});

// const TiYaraBanner = new Banner({
//   templateId: 'ti-lookup-banner',
//   finishDate: '2024-05-14T15:00:00.000Z',
// });

// const springSaleBanner = new Banner({
//   templateId: 'spring-sale-banner',
//   startDate: '2024-05-15T08:00:00.000Z',
//   finishDate: '2024-06-01T06:59:00.000Z',
// });

// const safebrowsingBanner = new Banner({
//   templateId: 'safebrowsing-banner',
//   startDate: '2024-08-15T08:00:00.000Z',
// });

const tiWebinarBanner = new Banner({
  templateId: 'ti-webinar-banner',
  finishDate: '2024-10-23T14:00:00.000Z',
});
